<script>
import config from "../../config";
import Layout from '../../layouts/main'
import PageHeader from '../../components/page-header'
import { customerService, vendorService} from '../../services';
import { error_message ,success_message} from "../../Helper/helper"
import {required,email,requiredIf}from "vuelidate/lib/validators";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import { routes } from "../../config/api_routes";
/**
 * Add-product component
 */
export default {
    components: { Layout, PageHeader, DropzonePopup},
    data() {
        return {
            config:config,
            business_type :"",
            is_contact : 1,
            timezones: "",
            typeform: {
                user_role: "",
                user_name: "",
                last_name: "",
                email: "",
                mobile_number: "",
                city: "",
                street: "",
                apartment: "",
                street_no: "",
                postal_code: "",
                address: "",
                user_profile:"",
                name : "",
                hrb : "",
                vat : "",
                company_logo : "",
                person_first_name : "",
                person_last_name : "",
                person_phone : "",
                person_email : "",
                is_contact_person : "0",
                business_user_name: "",
                business_last_name: "",
                business_email: "",
                business_mobile_number: "",
                business_city: "",
                business_postal_code: "",
                notes: "",
                parking_place:"",
                //parking_note: "",
                status: ""
            },
            typesubmit: false,
            profile_name : "",
            profile_media_path : "",
            profile_image_delete_url : routes.userProfileDeleteUrl,
            logo_image : "",
            logo_media_path : "",
            logo_delete_url : routes.companyLogoDeleteUrl,
        };
    },
    validations: {
        typeform: {
            user_role: {
                required,
            },
            user_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            email: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
                email
            },
            mobile_number: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            city: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            // user_profile: {
            //     required : requiredIf(function(form){
            //         return !(!!this.profile_name || !!this.typeform.user_profile) && this.business_type == 'Private';
            //     }),
            // },
            street: {
                required,
            },
            street_no: {
                required,
            }, 
            postal_code: {
                required : requiredIf(function(form){
                    return this.business_type == 'Private';
                }),
            },
            business_postal_code: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            // parking_note: {
            //     required : requiredIf(function(form){
            //         return this.business_type == 'Business';
            //     }),
            // },
            business_user_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            business_last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            business_email: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
                email
            },
            business_mobile_number: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            // business_time_zone: {
            //     required : requiredIf(function(form){
            //         return this.business_type == 'Business';
            //     }),
            // },
            business_city: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            hrb: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            vat: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business';
                }),
            },
            // company_logo: {
            //     required : requiredIf(function(form){
            //         return !(!!this.logo_image || !!this.typeform.company_logo) && this.business_type == 'Business';
            //     }),
            // },
            person_first_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            },
            person_last_name: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            },
            person_phone: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
            }, 
            person_email: {
                required : requiredIf(function(form){
                    return this.business_type == 'Business' && this.is_contact == '1';
                }),
                email
            },
        },
    },
    mounted(){
        this.getCustomerProfile();
        //this.getLanguage();
    },
    methods: {
        onImagedeleted(value) {
            this.profile_name = "";
        },
        onLogodeleted(value) {
            this.logo_image = "";
        },
        vatNumber(e){   
            const floating = /^[A-Za-z0-9 ]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        alphabetic(e){   
            const floating = /^[A-Za-z ]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        hrbNumber(e){   
            const floating = /^[A-Za-z0-9-]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        contactNumber(evt) {
            let val1 = evt.target.value;
            if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
                evt.preventDefault();
            }
            let partlen = val1.split("+").length - 1;
            if (evt.keyCode == 43 && partlen > 0) {
                evt.preventDefault();
            } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
                evt.preventDefault();
            }
        },
        getLanguage(){
            vendorService.getLanguage()
            .then(response => {
                this.timezones  = response.data.result.timezone;
            });
        },
        getCustomerProfile(){
            customerService.getCustomerProfile({user_id: this.$route.params.user_id})
            .then(response => {
                this.business_type = response.data.result.user_role;
                if(this.business_type == "Business"){
                    const{id, person_id, hrb, vat, user_id, business_user_name, apartment, notes, business_last_name, business_email, business_mobile_number, business_city, business_postal_code, street, street_no, name, user_role, person_first_name, person_last_name, person_phone, is_contact_person, person_email, status} = response.data.result;
                    this.typeform = {id, person_id, hrb, vat, user_id, business_user_name, apartment, notes, business_last_name, business_email, business_mobile_number, business_city, business_postal_code, street, street_no, name, user_role, person_first_name, person_last_name, person_phone, is_contact_person, person_email, status};
                    this.logo_image = response.data.result.company_logo;
                    this.is_contact = response.data.result.is_contact_person;
                    this.logo_media_path = response.data.result.company_media_path;
                }else{
                    const{user_id,user_name, last_name, email, mobile_number, city, apartment, street, street_no, postal_code, user_role, notes, parking_place, status} = response.data.result;
                    this.typeform = {user_id,user_name, last_name, email, mobile_number, city, apartment, street, street_no, postal_code, user_role, notes, parking_place, status};
                    this.profile_name = response.data.result.user_profile;
                    this.profile_media_path = response.data.result.profile_media_path;
                }
            });
        },
        onRoleChange(){
            this.business_type = this.typeform.user_role;
        },
        onStatusChange(){
            this.is_contact = this.typeform.is_contact_person;
        },
        updateCustomer(e) {
            this.$v.$touch();
            if (this.$v.typeform.$invalid) {
                setTimeout(()=>{
                    $('html, body').animate({
                        scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
                    }, 200, function() {
                        $(".is-invalid:first").focus();
                    });
                },300);
                return;
            }
            else{
                customerService.updateCustomerProfile(this.typeform)
                .then(response => {
                if (response.data.code === 200) {
                    success_message(response.data.message);
                    this.$router.push({ name: "customer-list" });
                } else {
                    error_message(response.data.message);
                }
                });
            }  
        } 
    }
};
</script>

<template>
    <form @submit.prevent="updateCustomer">
        <!-- Business Type Info Start -->
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Business Type Info') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group" v-if="$auth.setting">
                            <input
                                name="user_role"
                                class="form-control"
                                id="user_role"
                                v-model="$v.typeform.user_role.$model"
                                :class="{ 'is-invalid':$v.typeform.user_role.$error }"
                                readonly
                            />
                            <!-- <select
                                name="user_role"
                                class="custom-select"
                                id="user_role"
                                v-model="$v.typeform.user_role.$model"
                                :class="{ 'is-invalid':$v.typeform.user_role.$error }"
                                @change="onRoleChange()"
                            >
                                <option value="">{{ trans.get('__JSON__.Select Section Design Type') }}</option>
                                <option value="Private" selected>Private</option>
                                <option value="Business">Business</option>
                            </select> -->
                            <div v-if="$v.typeform.user_role.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.user_role.required">{{ trans.get('__JSON__.Please select business type') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Business Type Info End -->

        <!-- Private Start -->
        <div class="card" v-if="this.business_type == 'Private'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Private Customer') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.CEO First Name')}}</label>
                            <input
                                id="user_name"
                                v-model="$v.typeform.user_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.CEO First Name')"
                                name="user_name"
                                :class="{ 'is-invalid': $v.typeform.user_name.$error }"
                            />
                            <div v-if="$v.typeform.user_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.user_name.required">{{ trans.get('__JSON__.Please enter ceo first name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.CEO Last Name')}}</label>
                            <input
                                id="last_name"
                                v-model="$v.typeform.last_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.CEO Last Name')"
                                name="last_name"
                                :class="{ 'is-invalid': $v.typeform.last_name.$error }"
                            />
                            <div v-if="$v.typeform.last_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.last_name.required">{{ trans.get('__JSON__.Please enter ceo last name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="email"
                                v-model="$v.typeform.email.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="email"
                                :class="{ 'is-invalid': $v.typeform.email.$error }"
                            />
                            <div v-if="$v.typeform.email.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                <span v-if="!$v.typeform.email.email" v-cloak>{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="mobile_number"
                                v-model="$v.typeform.mobile_number.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="mobile_number"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.mobile_number.$error }"
                            />
                            <div v-if="$v.typeform.mobile_number.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.mobile_number.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Floor')}}</label>
                            <input
                                maxlength="2"
                                minlength="1"
                                id="apartment"
                                v-model="typeform.apartment"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Floor')"
                                name="apartment"
                                @keypress="contactNumber($event)"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street')}}</label>
                            <input
                                id="street"
                                v-model="$v.typeform.street.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street')"
                                name="street"
                                v-on:keypress="alphabetic($event,typeform.street)"
                                :class="{ 'is-invalid': $v.typeform.street.$error }"
                            />
                            <div v-if="$v.typeform.street.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street.required">{{ trans.get('__JSON__.Please enter street name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street Number')}}</label>
                            <input
                                maxlength="11"
                                minlength="1"
                                id="street_no"
                                v-model="$v.typeform.street_no.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street Number')"
                               
                                name="street_no"
                                :class="{ 'is-invalid': $v.typeform.street_no.$error }"
                            />
                            <!--  @keypress="contactNumber($event)" -->
                            <div v-if="$v.typeform.street_no.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street_no.required">{{ trans.get('__JSON__.Please enter street number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Postal Code')}}</label>
                            <input
                                maxlength="5"
                                minlength="5"
                                id="postal_code"
                                v-model="$v.typeform.postal_code.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Postal Code')"
                                name="postal_code"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.postal_code.$error }"
                            />
                            <div v-if="$v.typeform.postal_code.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.postal_code.required">{{ trans.get('__JSON__.Please enter postal code') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.City')}}</label>
                            <input
                                id="city"
                                v-model="$v.typeform.city.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.City')"
                                name="city"
                                :class="{ 'is-invalid': $v.typeform.city.$error }"
                                v-on:keypress="alphabetic($event,typeform.city)"
                            />
                            <div v-if="$v.typeform.city.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.city.required">{{ trans.get('__JSON__.City Name Error') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 vendor-status">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Status')" label-for="Parking Place" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="status"
                                            v-model="typeform.status"
                                            true-value="0"
                                            false-value="1"
                                        />
                                        <div class="slider round">
                                            <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-4 vendor-status" v-if="this.business_type == 'Private'">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Parking Place')" label-for="Parking Place" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="parking_place"
                                            v-model="typeform.parking_place"
                                            true-value="1"
                                            false-value="0"
                                        />
                                        <div class="slider round">
                                            <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.No') }}</span>
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Message From Customer')}}</label>
                            <textarea
                                rows="5"
                                id="notes"
                                v-model="typeform.notes"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Message From Customer')"
                                name="notes"
                            ></textarea>
                        </div>
                    </div>
                    
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Profile Image')}}</label>
                            <dropzone-popup
                                v-model="typeform.user_profile"
                                id="profile_name"
                                acceptedFiles=".jpeg,.jpg,.png"
                                :editable-images="profile_name"
                                :media-path="profile_media_path+'/original'"
                                :delete-path="profile_image_delete_url"
                                @image-deleted="this.onImagedeleted"
                            />
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Update') }}</button>
                        <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Private End -->

        <!-- Business Start -->
        <div class="card" v-if="this.business_type == 'Business'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Company Details') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Company Name')}}</label>
                            <input
                                id="name"
                                v-model="$v.typeform.name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Company Name')"
                                name="name"
                                :class="{ 'is-invalid': $v.typeform.name.$error }"
                            />
                            <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.name.required">{{ trans.get('__JSON__.Please enter company name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.First Name')}}</label>
                            <input
                                id="business_user_name"
                                v-model="$v.typeform.business_user_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.First Name')"
                                name="business_user_name"
                                :class="{ 'is-invalid': $v.typeform.business_user_name.$error }"
                            />
                            <div v-if="$v.typeform.business_user_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_user_name.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Last Name')}}</label>
                            <input
                                id="business_last_name"
                                v-model="$v.typeform.business_last_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Last Name')"
                                name="business_last_name"
                                :class="{ 'is-invalid': $v.typeform.business_last_name.$error }"
                            />
                            <div v-if="$v.typeform.business_last_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_last_name.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="business_email"
                                v-model="$v.typeform.business_email.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="business_email"
                                :class="{ 'is-invalid': $v.typeform.business_email.$error }"
                            />
                            <div v-if="$v.typeform.business_email.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                <span v-if="!$v.typeform.business_email.email" v-cloak>{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.HRB')}}</label>
                            <input
                                minlength="5"
                                id="hrb"
                                v-model="$v.typeform.hrb.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.HRB')"
                                name="hrb"
                                v-on:keypress="hrbNumber($event,typeform.hrb)"
                                :class="{ 'is-invalid': $v.typeform.hrb.$error }"
                            />
                            <div v-if="$v.typeform.hrb.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.hrb.required">{{ trans.get('__JSON__.Please enter hrb') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Tax')}}</label>
                            <div class="input-group mb-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text h-100 cust-input">DE</div>
                                </div>
                                <input
                                    maxlength="13"
                                    id="vat"
                                    v-model="$v.typeform.vat.$model"
                                    type="text"
                                    class="form-control"
                                    :placeholder="trans.trans('__JSON__.Tax')"
                                    name="vat"
                                    v-on:keypress="vatNumber($event,typeform.vat)"
                                    :class="{ 'is-invalid': $v.typeform.vat.$error }"
                                />
                            </div>
                            
                            <div v-if="$v.typeform.vat.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.vat.required">{{ trans.get('__JSON__.Please enter vat') }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!-- Business End -->

        <!-- Company Address Start -->
        <div class="card" v-if="this.business_type == 'Business'">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Company Address') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="business_mobile_number"
                                v-model="$v.typeform.business_mobile_number.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="business_mobile_number"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.business_mobile_number.$error }"
                            />
                            <div v-if="$v.typeform.business_mobile_number.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_mobile_number.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Floor')}}</label>
                            <input
                                maxlength="2"
                                minlength="1"
                                id="apartment"
                                v-model="typeform.apartment"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Floor')"
                                name="apartment"
                                @keypress="contactNumber($event)"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street')}}</label>
                            <input
                                id="street"
                                v-model="$v.typeform.street.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street')"
                                name="street"
                                v-on:keypress="alphabetic($event,typeform.street)"
                                :class="{ 'is-invalid': $v.typeform.street.$error }"
                            />
                            <div v-if="$v.typeform.street.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street.required">{{ trans.get('__JSON__.Please enter street name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street Number')}}</label>
                            <input
                                maxlength="11"
                                minlength="1"
                                id="street_no"
                                v-model="$v.typeform.street_no.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street Number')"
                               
                                name="street_no"
                                :class="{ 'is-invalid': $v.typeform.street_no.$error }"
                            />
                            <!--  @keypress="contactNumber($event)" -->
                            <div v-if="$v.typeform.street_no.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street_no.required">{{ trans.get('__JSON__.Please enter street number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Postal Code')}}</label>
                            <input
                                maxlength="5"
                                minlength="5"
                                id="business_postal_code"
                                v-model="$v.typeform.business_postal_code.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Postal Code')"
                                name="business_postal_code"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.business_postal_code.$error }"
                            />
                            <div v-if="$v.typeform.business_postal_code.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_postal_code.required">{{ trans.get('__JSON__.Please enter postal code') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.City')}}</label>
                            <input
                                id="business_city"
                                v-model="$v.typeform.business_city.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.City')"
                                name="business_city"
                                v-on:keypress="alphabetic($event,typeform.business_city)"
                                :class="{ 'is-invalid': $v.typeform.business_city.$error }"
                            />
                            <div v-if="$v.typeform.business_city.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.business_city.required">{{ trans.get('__JSON__.City Name Error') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 vendor-status">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Status')" label-for="Parking Place" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="status"
                                            v-model="typeform.status"
                                            true-value="0"
                                            false-value="1"
                                        />
                                        <div class="slider round">
                                            <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-sm-4">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Is Contact Person')" label-for="Is Contact Person" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                        <input
                                            type="checkbox"
                                            id="togBtn"
                                            class="switch-on"
                                            name="is_contact_person"
                                            v-model="typeform.is_contact_person"
                                            true-value="1"
                                            false-value="0"
                                            @change="onStatusChange"
                                        />
                                        <div class="slider round">
                                            <!--ADDED HTML -->
                                            <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                                            <span class="off">{{ trans.get('__JSON__.No') }}</span>
                                            <!--END-->
                                        </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Company Logo')}}</label>
                            <dropzone-popup
                                v-model="typeform.company_logo"
                                id="logo_image"
                                acceptedFiles=".jpeg,.jpg,.png"
                                :editable-images="logo_image"
                                :media-path="logo_media_path+'/original'"
                                :delete-path="logo_delete_url"
                                @image-deleted="this.onLogodeleted"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Message From Customer')}}</label>
                            <textarea
                                rows="5"
                                v-model="typeform.notes"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Message From Customer')"
                                name="notes"
                            ></textarea>
                        </div>
                    </div>

                    <!-- <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Parking Note')}}</label>
                            <textarea
                                rows="5"
                                id="parking_note"
                                v-model="$v.typeform.parking_note.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Parking Note')"
                                name="parking_note"
                                :class="{ 'is-invalid': $v.typeform.parking_note.$error }"
                            ></textarea>
                            <div v-if="$v.typeform.parking_note.$error" class="invalid-feedback">
                                <span
                                    v-if="!$v.typeform.parking_note.required"
                                >{{ trans.get('__JSON__.Please enter parking note') }}.</span>
                            </div>
                        </div>
                    </div> -->

                </div>

                <div class="row" v-if="this.business_type == 'Business' && this.is_contact == 0">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Update') }}</button>
                        <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Company Address End -->

        <!-- Compant Start -->
        <div class="card" v-if="this.business_type == 'Business' && this.is_contact == 1">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Contact Person') }}</h4>
                <p class="card-title-desc"></p>
                
                <div class="row">

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.First Name')}}</label>
                            <input
                                id="person_first_name"
                                v-model="$v.typeform.person_first_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.First Name')"
                                name="person_first_name"
                                :class="{ 'is-invalid': $v.typeform.person_first_name.$error }"
                            />
                            <div v-if="$v.typeform.person_first_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_first_name.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Last Name')}}</label>
                            <input
                                id="person_last_name"
                                v-model="$v.typeform.person_last_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Last Name')"
                                name="person_last_name"
                                :class="{ 'is-invalid': $v.typeform.person_last_name.$error }"
                            />
                            <div v-if="$v.typeform.person_last_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_last_name.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Phone')}}</label>
                            <input
                                maxlength="12"
                                minlength="9"
                                id="person_phone"
                                v-model="$v.typeform.person_phone.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone')"
                                name="person_phone"
                                @keypress="contactNumber($event)"
                                :class="{ 'is-invalid': $v.typeform.person_phone.$error }"
                            />
                            <div v-if="$v.typeform.person_phone.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_phone.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="person_email"
                                v-model="$v.typeform.person_email.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="person_email"
                                :class="{ 'is-invalid': $v.typeform.person_email.$error }"
                            />
                            <div v-if="$v.typeform.person_email.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.person_email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                                <span v-if="!$v.typeform.person_email.email" v-cloak>{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                            </div>
                        </div>
                    </div> 
                </div>
                <div class="row" v-if="this.business_type == 'Business' && this.is_contact == 1">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Update') }}</button>
                        <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                        <router-link
                            :to="{name:'customer-list'}"
                        >
                            <b-button 
                                @click="$router.go(-1)" 
                                type="button" 
                                variant="secondary" 
                                class="mt-3">
                                {{ trans.get('__JSON__.Cancel') }}
                            </b-button>
                        </router-link>                            
                    </div>
                </div>
            </div>
        </div>
        <!-- Business End -->
    </form>
</template>
